import { isDraft, original, type PayloadAction } from '@reduxjs/toolkit';
import type { EditorScreen } from '../editorSlice';
import type { EditorState } from './state';

/**
 * WEB-4088 (решение оркестратора 30.10 Л5) — правка окошка правила у
 * открытого экрана (линза «Логика», метки «куда ведёт»): экраны и правила
 * части одной правкой истории. Окошко считает их тем же `applyRuleDraft` /
 * `removeEdgeRule` карты (`funnel-canvas/canvasRules.ts`); здесь — только
 * запись. Два шага истории (сперва экраны, потом правила) не принимаются:
 * одна отмена обязана вернуть всё.
 *
 * Те же ссылки, что были, — правки нет: возвращается само состояние, и
 * `applyHistoryIfChanged` шага истории не заводит (в редьюсере состояние —
 * черновик immer, сравнивать надо с его исходником). Живёт вне фасада editorSlice.ts
 * (храповик длины WEB-2552); создатель и регистрация —
 * `./screenFieldActions.ts`.
 */
export interface ContentAndLogicPayload {
  content: EditorScreen[];
  logic: EditorState['logic'];
}

export function setContentAndLogicReducer(
  state: EditorState,
  action: PayloadAction<ContentAndLogicPayload>,
): EditorState {
  const { content, logic } = action.payload;
  const was = isDraft(state) ? (original(state) ?? state) : state;
  if (content === was.content && logic === was.logic) return state;
  return { ...state, content, logic, isDirty: true };
}
